import { concat, OperatorFunction, SchedulerLike } from "rxjs";
import { debounceTime, publish, take, throttleTime } from "rxjs/operators";

export function debounceTimeAfter<T>(
	amount: number,
	dueTime: number,
	scheduler?: SchedulerLike
): OperatorFunction<T, T> {
	return publish((value) => concat(value.pipe(take(amount)), value.pipe(debounceTime(dueTime, scheduler))));
}

export function debounceTimeAfterFirst<T>(dueTime: number, scheduler?: SchedulerLike): OperatorFunction<T, T> {
	return debounceTimeAfter<T>(1, dueTime, scheduler);
}
export function throttleTimeAfter<T>(
	amount: number,
	dueTime: number,
	scheduler?: SchedulerLike
): OperatorFunction<T, T> {
	return publish((value) => concat(value.pipe(take(amount)), value.pipe(throttleTime(dueTime, scheduler))));
}

export function throttleTimeAfterFirst<T>(dueTime: number, scheduler?: SchedulerLike): OperatorFunction<T, T> {
	return throttleTimeAfter<T>(1, dueTime, scheduler);
}
